<main class="connect-page">
    <header class="page-heading">
        <p class="eyebrow">Yard Garage Moving Sales</p>
        <h1>Connect with us</h1>
    </header>

    <section class="content-section" aria-labelledby="featured-videos-title">
        <h2 id="featured-videos-title">Check out our videos</h2>
        <table class="link-table video-table">
            <caption class="visually-hidden">Introductory videos</caption>
            <tbody>
                <tr>
                    <td>
                        <a class="video-link" href="https://youtu.be/HCtZvxBjgkc" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/HCtZvxBjgkc/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Who we are</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                    <td>
                        <a class="video-link" href="https://youtu.be/-IZw04_2F1Q" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/-IZw04_2F1Q/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Benefits</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                    <td>
                        <a class="video-link" href="https://youtu.be/1vwtR5PEKfE" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/1vwtR5PEKfE/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Tour Guide</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>

    <section class="content-section" aria-labelledby="video-stories-title">
        <h2 id="video-stories-title">Video Stories</h2>
        <table class="link-table video-table">
            <caption class="visually-hidden">Customer video stories</caption>
            <tbody>
                <tr>
                    <td>
                        <a class="video-link" href="https://youtu.be/dB-Bgdcitd8" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/dB-Bgdcitd8/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Singh's Rendezvous - A Yard Sale That Turned Neighbors into Friends</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                    <td>
                        <a class="video-link" href="https://youtu.be/BbgaRnxCarI" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/BbgaRnxCarI/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Nick’s Decluttering Idea!</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                    <td>
                        <a class="video-link" href="https://youtu.be/ToHG6CgB4v0" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/ToHG6CgB4v0/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Victor’s Moving Helper</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                    <td>
                        <a class="video-link" href="https://youtube.com/shorts/2UR0wTG8y6k" target="_blank"
                            rel="noopener noreferrer">
                            <img src="https://img.youtube.com/vi/2UR0wTG8y6k/hqdefault.jpg" alt="" loading="lazy">
                            <span class="video-title">Jessica’s 40 years of memories</span>
                            <span class="play-indicator" aria-hidden="true">Play video</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>

    <section class="content-section" aria-labelledby="sale-events-title">
        <h2 id="sale-events-title">Broadcast or Search for a Sale Event</h2>
        <table class="link-table action-table">
            <caption class="visually-hidden">Sale event actions</caption>
            <tbody>
                <tr>
                    <td>
                        <a class="action-link" href="https://yardgaragemovingsales.com/subscription-tier">
                            <span class="action-label">Broadcast an event</span>
                            <span class="action-arrow" aria-hidden="true">&#8594;</span>
                        </a>
                    </td>
                    <td>
                        <a class="action-link" href="https://yardgaragemovingsales.com/search-sale">
                            <span class="action-label">Search for an Event</span>
                            <span class="action-arrow" aria-hidden="true">&#8594;</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>

    <section class="content-section" aria-labelledby="social-title">
        <h2 id="social-title">Follow us on Social Media for Latest updates</h2>
        <table class="link-table social-table">
            <caption class="visually-hidden">Follow Yard Garage Moving Sales online</caption>
            <tbody>
                <tr>
                    <td>
                        <a class="social-link" href="https://instagram.com/yardgaragemovesale?vrfl=M2dlajAwN2JjcWpn"
                            target="_blank" rel="noopener noreferrer">
                            <span class="social-mark" aria-hidden="true">IG</span><span>Follow us on Instagram</span>
                        </a>
                    </td>
                    <td>
                        <a class="social-link" href="https://www.facebook.com/YardGarageMovingSales" target="_blank"
                            rel="noopener noreferrer">
                            <span class="social-mark" aria-hidden="true">f</span><span>Follow us on FaceBook</span>
                        </a>
                    </td>
                    <td>
                        <a class="social-link" href="https://yardgaragemovingsalessspace.quora.com/" target="_blank"
                            rel="noopener noreferrer">
                            <span class="social-mark" aria-hidden="true">Q</span><span>Follow us on Quora</span>
                        </a>
                    </td>
                    <td>
                        <a class="social-link" href="https://youtube.com/@yardgaragemovingsales?si=S-doY0US73bcZCEb"
                            target="_blank" rel="noopener noreferrer">
                            <span class="social-mark" aria-hidden="true">&#9654;</span><span>Subscribe to our
                                Channel</span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</main>